import React, { Component } from "react";
import { Link } from "react-router-dom";
import withRouter from "../withRouter.js";
import {
  clientname,
  currentTenant,
  logo,
  thousandsdisplay,
  userid,
  currency
} from "../Common/Credentials.js";
import { spin } from "../Common/NewLoader.jsx";
import { assetmanagementid } from "../Common/Permissions.js";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu.js";

import { NumericFormat } from "react-number-format";
import {
  FormControlLabel,
  Grid,
  Tooltip,
  TextField,
  MenuItem,
} from "@mui/material";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import AssetsService from "./AssetsService.js";
import moment from "moment";
import IOSSwitch from "../CommonComponents/IOSSwitch.js";
import UpArrow from "../images/Icons/up-arrow.png";
import ViewIcon from "../images/Icons/preview.png";

// Import CSS
import "../NewUI/NewUI.css";

const TabButton = ({ active, onClick, children }) => (
  <fieldset
    onClick={onClick}
    className={`UI-tab-button ${active ? "UI-active-tab" : "UI-inactive-tab"}`}
    style={{
      cursor: "pointer",
      transition: "all 0.3s ease",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "6px",
      padding: "8px 16px",
      fontSize: "0.8rem",
      fontWeight: 500,
      textWrap: "nowrap",
    }}
  >
    {children}
    <img
      src={UpArrow}
      alt="Up Arrow"
      className="UI-tab-arrow"
      style={{
        transform: active ? "rotate(30deg)" : "rotate(0deg)",
      }}
    />
  </fieldset>
);

class AssetTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      data: [],
      thirdpartyassets: [],
      rentdata: [],
      rentalquotation: [],
      solddata: [],
      soldquotations: [],
      message: "",

      // UI State
      isMobile: window.innerWidth <= 768,
      currentView: 'list',
      selectedAsset: null,
      searchTerm: "",
      showSearch: false,
      hovered: null,
      hoveredRow: null,
      isActionHovered: null,
      filteredData: [],
      filteredSidebarData: [],
      currentPage: 1,
      itemsPerPage: 20,
      hasScrolledToSelected: false,
      sortConfig: { key: 'itemname', direction: 'asc' },
      initialLoad: true,
      exportDropdownOpen: false,

      // Tab State
      type: "Assets", // First degree: Assets, Rental, Sales
      assetType: "Own", // For Assets tab: Own, Thirdparty
      rentalType: "Rental", // For Rental tab: Rental, Quotation
      salesType: "Sales", // For Sales tab: Sales, Quotation
    };

    this.handleResize = this.handleResize.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.Refresh = this.Refresh.bind(this);
    this.toggleExportDropdown = this.toggleExportDropdown.bind(this);
    this.closeExportDropdown = this.closeExportDropdown.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.exportPDF = this.exportPDF.bind(this);
    this.handleAssetClick = this.handleAssetClick.bind(this);
    this.handleBackToList = this.handleBackToList.bind(this);
    this.renderTable = this.renderTable.bind(this);
    this.renderTypeTabs = this.renderTypeTabs.bind(this);
    this.renderStatusTabs = this.renderStatusTabs.bind(this);
    this.renderListView = this.renderListView.bind(this);
    this.renderDetailView = this.renderDetailView.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleItemsPerPageChange = this.handleItemsPerPageChange.bind(this);
    this.renderPagination = this.renderPagination.bind(this);
    this.sortData = this.sortData.bind(this);
    this.getSortedData = this.getSortedData.bind(this);
    this.formatCurrency = this.formatCurrency.bind(this);
    this.highlightSearchText = this.highlightSearchText.bind(this);
    this.escapeRegex = this.escapeRegex.bind(this);
    this.getCurrentData = this.getCurrentData.bind(this);
    this.updateFilteredData = this.updateFilteredData.bind(this);
    this.sidebarRef = React.createRef();
    this.scrollTimeout = null;
    this.exportRef = React.createRef();
  }

  // Sort indicator component
  SortIndicator = ({ columnKey }) => {
    if (this.state.sortConfig.key !== columnKey) {
      return <i className="fa fa-sort UI-sort-icon" />;
    }
    return this.state.sortConfig.direction === 'asc'
      ? <i className="fa fa-sort-up UI-sort-icon UI-sort-active" />
      : <i className="fa fa-sort-down UI-sort-icon UI-sort-active" />;
  }

  // Sorting function
  sortData(key) {
    let direction = 'asc';
    if (this.state.sortConfig.key === key && this.state.sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    this.setState({ sortConfig: { key, direction } });
  }

  getSortedData(data) {
    if (!this.state.sortConfig.key) return data;

    return [...data].sort((a, b) => {
      let aValue, bValue;

      switch (this.state.sortConfig.key) {
        case 'itemname':
          aValue = a.itemname || '';
          bValue = b.itemname || '';
          break;
        case 'customid':
          aValue = a.customid || '';
          bValue = b.customid || '';
          break;
        case 'createdAt':
          aValue = new Date(a.createdAt).getTime();
          bValue = new Date(b.createdAt).getTime();
          break;
        case 'baseamount':
          aValue = Number(a.baseamount) || 0;
          bValue = Number(b.baseamount) || 0;
          break;
        case 'totalamountinctax':
          aValue = Number(a.totalamountinctax) || 0;
          bValue = Number(b.totalamountinctax) || 0;
          break;
        default:
          aValue = a[this.state.sortConfig.key] || '';
          bValue = b[this.state.sortConfig.key] || '';
      }

      if (aValue < bValue) {
        return this.state.sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return this.state.sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  escapeRegex(string) {
    if (!string) return '';
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlightSearchText(text, searchTerm) {
    if (!searchTerm?.trim() || !text) return text;

    const rawText = String(text);
    const escapedSearchTerm = this.escapeRegex(searchTerm);

    if (escapedSearchTerm.length > 50) {
      return rawText;
    }

    try {
      const regex = new RegExp(`(${escapedSearchTerm})`, 'gi');
      const parts = rawText.split(regex);

      return parts.map((part, index) =>
        regex.test(part)
          ? React.createElement('mark', {
            key: index,
            className: 'UI-search-highlight'
          }, part)
          : part
      );
    } catch (error) {
      console.warn('Regex error in search:', error);
      return rawText;
    }
  }

  formatCurrency(value) {
    if (value === null || value === undefined) return '0';

    const prefix = currency === "INR" ? "₹ " : currency === "USD" ? "$ " : currency + " ";

    return (
      <NumericFormat
        displayType={"text"}
        value={value}
        decimalScale={2}
        fixedDecimalScale={true}
        thousandSeparator={true}
        thousandsGroupStyle={thousandsdisplay}
        prefix={prefix.trim()}
      />
    );
  }

  formatCurrencyAsString(value) {
    if (value === null || value === undefined) return '0.00';

    return new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }

  handleResize() {
    const isMobile = window.innerWidth <= 768;
    this.setState({ isMobile });
    if (!isMobile) {
      this.setState({ showSearch: false });
    }
  }

  componentDidMount() {
    if (window.innerWidth <= 768) {
      this.setState({ showSearch: true });
    }
    window.addEventListener('resize', this.handleResize);
    document.addEventListener('mousedown', this.handleClickOutside);

    if (userid === undefined) {
      window.confirm("Your Session is Lost: Please login Back to resume");
      this.props.navigate(`/`);
    }
    this.setState({ loading: true });
    this.Refresh();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.currentView === 'detail' &&
      this.state.selectedAsset &&
      this.sidebarRef.current &&
      !this.state.hasScrolledToSelected) {

      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }

      this.scrollTimeout = setTimeout(() => {
        const selectedElement = this.sidebarRef.current.querySelector(`[data-asset-id="${this.state.selectedAsset.id}"]`);
        if (selectedElement) {
          selectedElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          this.setState({ hasScrolledToSelected: true });
        }
      }, 100);
    }

    if (prevState.currentView !== this.state.currentView && this.state.currentView === 'list') {
      this.setState({ hasScrolledToSelected: false });
    }

    if (prevState.selectedAsset?.id !== this.state.selectedAsset?.id) {
      this.setState({ hasScrolledToSelected: false });
    }

    if (prevState.type !== this.state.type ||
      prevState.assetType !== this.state.assetType ||
      prevState.rentalType !== this.state.rentalType ||
      prevState.salesType !== this.state.salesType) {
      this.updateFilteredData();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('mousedown', this.handleClickOutside);
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
  }

  handleClickOutside = (event) => {
    if (this.exportRef.current && !this.exportRef.current.contains(event.target)) {
      this.setState({ exportDropdownOpen: false });
    }
  };

  Refresh() {
    this.setState({ loading: true });

    Promise.all([
      AssetsService.getallAssets(currentTenant),
      AssetsService.GetThirdpartyassets(currentTenant),
      AssetsService.GetRentassetsoftTenant(currentTenant),
      AssetsService.GetSoldassetsoftTnant(currentTenant),
      AssetsService.GetSoldQuotationofTenant(currentTenant),
      AssetsService.GetRentalQuotationofTenant(currentTenant)
    ]).then(([assetsRes, thirdPartyRes, rentRes, soldRes, soldQuotationsRes, rentalQuotationRes]) => {
      this.setState({
        data: assetsRes.data.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1),
        thirdpartyassets: thirdPartyRes.data.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1),
        rentdata: rentRes.data.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1),
        solddata: soldRes.data.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1),
        soldquotations: soldQuotationsRes.data.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1),
        rentalquotation: rentalQuotationRes.data.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1)
      }, () => {
        this.updateFilteredData();
      });
    }).finally(() => {
      this.setState({ loading: false });
    });
  }

  updateFilteredData() {
    const { searchTerm, type, assetType, rentalType, salesType } = this.state;

    let data = [];
    if (type === "Assets") {
      if (assetType === "Own") data = this.state.data;
      else if (assetType === "Thirdparty") data = this.state.thirdpartyassets;
    } else if (type === "Rental") {
      if (rentalType === "Rental") data = this.state.rentdata;
      else if (rentalType === "Quotation") data = this.state.rentalquotation;
    } else if (type === "Sales") {
      if (salesType === "Sales") data = this.state.solddata;
      else if (salesType === "Quotation") data = this.state.soldquotations;
    }

    if (!searchTerm.trim()) {
      this.setState({
        filteredData: data,
        filteredSidebarData: this.state.currentView === 'detail' ? data : data,
        currentPage: 1,
        loading: false
      });
      return;
    }

    const cleanSearch = searchTerm.replace(/[^\w₹$€]/g, '').toLowerCase();

    const filtered = data.filter((item) => {
      const checkFields = [
        item.itemname,
        item.customid,
        item.category,
        item.assettype,
        item.serialno,
        item.warehouse,
        item.quantity?.toString(),
        item.baseamount?.toString(),
        item.type,
        item.depreciation?.toString(),
        item.depreciationperiod?.toString(),
        item.depreciationfrequency,
        item.location,
        item.user,
        item.assetstatus,
      ];

      // For rental and sales, check additional fields
      if (type === "Rental" || type === "Sales") {
        checkFields.push(
          item.customer,
          item.quotation,
          item.totalamountinctax?.toString(),
          item.createdby,
          item.invstatus
        );
      }

      return checkFields.some((field) => {
        if (field === undefined || field === null) return false;

        const raw = String(field);
        const cleanField = raw.replace(/[^\w₹$€]/g, '').toLowerCase();

        return (
          cleanField.includes(cleanSearch) ||
          raw.toLowerCase().includes(searchTerm.toLowerCase())
        );
      });
    });

    this.setState({
      filteredData: filtered,
      filteredSidebarData: this.state.currentView === 'detail' ? filtered : data,
      currentPage: 1,
      loading: false
    });
  }

  handleSearch(term) {
    this.setState({ searchTerm: term }, () => {
      this.updateFilteredData();
    });
  }

  getCurrentData() {
    const { type, assetType, rentalType, salesType } = this.state;

    if (type === "Assets") {
      if (assetType === "Own") return this.state.data;
      if (assetType === "Thirdparty") return this.state.thirdpartyassets;
    } else if (type === "Rental") {
      if (rentalType === "Rental") return this.state.rentdata;
      if (rentalType === "Quotation") return this.state.rentalquotation;
    } else if (type === "Sales") {
      if (salesType === "Sales") return this.state.solddata;
      if (salesType === "Quotation") return this.state.soldquotations;
    }
    return [];
  }

  getCurrentPageData() {
    const { filteredData, currentPage, itemsPerPage } = this.state;
    const sortedData = this.getSortedData(filteredData);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return sortedData.slice(indexOfFirstItem, indexOfLastItem);
  }

  handlePageChange(newPage) {
    this.setState({ currentPage: newPage });
  }

  handleItemsPerPageChange(e) {
    this.setState({
      itemsPerPage: parseInt(e.target.value),
      currentPage: 1
    });
  }

  handleAssetClick(asset) {
    this.setState({
      selectedAsset: asset,
      currentView: 'detail',
      hasScrolledToSelected: false
    }, () => {
      this.setState({
        filteredSidebarData: this.state.filteredData
      });
    });
  }

  handleBackToList() {
    this.setState({
      currentView: 'list',
      selectedAsset: null,
      hasScrolledToSelected: false
    }, () => {
      this.updateFilteredData();
    });
  }

  getCurrentStatusLabel() {
    const { type, assetType, rentalType, salesType } = this.state;

    if (type === "Assets") {
      if (assetType === "Own") return "Own Assets";
      if (assetType === "Thirdparty") return "Third Party Assets";
    } else if (type === "Rental") {
      if (rentalType === "Rental") return "Rental Assets";
      if (rentalType === "Quotation") return "Rental Quotations";
    } else if (type === "Sales") {
      if (salesType === "Sales") return "Sales Assets";
      if (salesType === "Quotation") return "Sales Quotations";
    }
    return "All";
  }

  toggleExportDropdown() {
    this.setState(prevState => ({
      exportDropdownOpen: !prevState.exportDropdownOpen
    }));
  }

  closeExportDropdown() {
    this.setState({ exportDropdownOpen: false });
  }

  exportPDF() {
    this.closeExportDropdown();

    const data = this.getCurrentData();
    const curdate = moment().format('DD-MM-YYYY HH:mm:ss');
    const statusLabel = this.getCurrentStatusLabel();
    const typeLabel = this.state.type;

    // Create PDF
    const doc = new jsPDF('l', 'mm', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const leftMargin = 15;
    const rightMargin = 10;
    const topMargin = 5;
    const bottomMargin = 10;
    const contentWidth = pageWidth - leftMargin - rightMargin;

    let yPosition = topMargin + 10;

    // Header
    doc.setFontSize(8);
    doc.setFont(undefined, 'bold');
    doc.text(clientname, leftMargin + 5, yPosition, {
      maxWidth: contentWidth * 0.9,
      align: 'left',
      overflow: 'linebreak'
    });

    const companyNameLines = doc.splitTextToSize(clientname, contentWidth * 0.9);
    const companyNameHeight = companyNameLines.length * 5;
    yPosition += companyNameHeight;

    // Document Title
    doc.setFontSize(7.5);
    doc.setFont(undefined, 'normal');
    doc.text(`${typeLabel} - ${statusLabel}`, leftMargin + 5, yPosition);
    yPosition += 4;

    // Date Range
    doc.setFontSize(7);
    doc.text(`Export Date: ${curdate}`, leftMargin + 5, yPosition);
    yPosition += 5;

    // Define columns based on type
    const columns = [];
    if (this.state.type === "Assets") {
      columns.push(
        { header: "ID", dataKey: 'customid' },
        { header: "Item Name", dataKey: 'itemname' },
        { header: "Category", dataKey: 'category' },
        { header: "Asset Type", dataKey: 'assettype' },
        { header: "Serial No.", dataKey: 'serialno' },
        { header: "Warehouse", dataKey: 'warehouse' },
        { header: "Quantity", dataKey: 'quantity' },
        { header: "Amount", dataKey: 'baseamount' },
        { header: "Type", dataKey: 'type' },
        { header: "Depreciation(%)", dataKey: 'depreciation' },
        { header: "Depreciation Period", dataKey: 'depreciationperiod' },
        { header: "Depreciation Frequency", dataKey: 'depreciationfrequency' },
        { header: "Location", dataKey: 'location' },
        { header: "User", dataKey: 'user' },
        { header: "Date", dataKey: 'createdAt' },
        { header: "Status", dataKey: 'assetstatus' }
      );
    } else if (this.state.type === "Rental" || this.state.type === "Sales") {
      columns.push(
        { header: "ID", dataKey: this.state.type === "Rental" && this.state.rentalType === "Rental" ? 'customid' : 'id' },
        this.state.type === "Rental" && this.state.rentalType === "Rental" ? { header: "Quotation", dataKey: 'quotation' } : null,
        this.state.type === "Sales" && this.state.salesType === "Sales" ? { header: "Quotation", dataKey: 'quotation' } : null,
        { header: "Customer", dataKey: 'customer' },
        { header: "Amount", dataKey: 'totalamountinctax' },
        { header: "Created By", dataKey: 'createdby' },
        { header: "Date", dataKey: 'createdAt' }
      );
      if ((this.state.type === "Rental" && this.state.rentalType === "Rental") ||
        (this.state.type === "Sales" && this.state.salesType === "Sales")) {
        columns.push({ header: "Invoice Status", dataKey: 'invstatus' });
      }
    }

    // Filter out null columns
    const filteredColumns = columns.filter(col => col !== null);

    // Prepare table data
    const tableData = data.map(item => {
      const row = {};
      filteredColumns.forEach(col => {
        if (col.dataKey === 'createdAt') {
          row[col.dataKey] = moment(item.createdAt).format('DD-MM-YYYY HH:mm');
        } else if (
          col.dataKey === 'baseamount' ||
          col.dataKey === 'totalamountinctax'
        ) {
          row[col.dataKey] = this.formatCurrencyAsString(
            item[col.dataKey] || 0
          );
        } else if (col.dataKey === 'quotation' && (!item[col.dataKey] || item[col.dataKey] === '')) {
          row[col.dataKey] = 'Direct';
        } else {
          row[col.dataKey] = item[col.dataKey] || '';
        }
      });
      return row;
    });

    // Generate table
    autoTable(doc, {
      startY: yPosition,
      margin: { left: leftMargin, right: rightMargin, top: 10, bottom: bottomMargin },
      tableWidth: contentWidth,
      head: [filteredColumns.map(col => col.header)],
      body: tableData.map(item =>
        filteredColumns.map(col => String(item[col.dataKey] || ''))
      ),
      theme: 'grid',
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontSize: 7,
        fontStyle: 'bold',
        halign: 'center',
        valign: 'middle',
        cellPadding: 3,
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
      },
      bodyStyles: {
        fontSize: 6,
        textColor: [0, 0, 0],
        cellPadding: 2,
        valign: 'middle',
        overflow: 'linebreak',
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
      },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      didDrawPage: (data) => {
        const footerY = pageHeight - bottomMargin + 5;
        doc.setFontSize(7);
        const pageText = `Page ${data.pageNumber} of ${data.pageCount}`;
        const textWidth = doc.getTextWidth(pageText);
        doc.text(pageText, leftMargin + (contentWidth - textWidth) / 2, footerY);
      },
    });

    const filename = `${clientname}_${typeLabel.replace(/\s+/g, '_')}_${statusLabel.replace(/\s+/g, '_')}_${moment().format('DDMMYYYY_HHmm')}.pdf`;
    doc.save(filename);
  }

  renderTable() {
    const isMobile = this.state.isMobile;
    const currentPageData = this.getCurrentPageData();
    const { type, assetType, rentalType, salesType } = this.state;

    if (this.state.filteredData.length === 0) {
      return (
        <div className={`UI-no-items-message ${isMobile ? 'UI-no-items-message-mobile' : ''}`}>
          {this.state.searchTerm ? 'No assets found matching your search' : 'No assets available'}
        </div>
      );
    }

    return (
      <>
        <div className={`UI-table-container ${isMobile ? 'UI-table-container-mobile' : ''}`}>
          <table className={`UI-table ${isMobile ? 'UI-table-mobile' : ''}`}>
            <thead className="UI-table-header">
              <tr>
                {type === "Assets" ? (
                  <>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'customid' ? 'UI-th-sorted' : ''}`}
                      onClick={() => this.sortData('customid')}
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="UI-th-content">
                        ID
                        <this.SortIndicator columnKey="customid" />
                      </div>
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'itemname' ? 'UI-th-sorted' : ''}`}
                      onClick={() => this.sortData('itemname')}
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="UI-th-content">
                        Item Name
                        <this.SortIndicator columnKey="itemname" />
                      </div>
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                    >
                      Category
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                    >
                      Asset Type
                    </th>
                    {assetType === "Own" && (
                      <>
                        <th
                          className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                        >
                          Serial No.
                        </th>
                        <th
                          className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                        >
                          Type
                        </th>
                      </>
                    )}
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                    >
                      Warehouse
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                    >
                      Quantity
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'baseamount' ? 'UI-th-sorted' : ''}`}
                      onClick={() => this.sortData('baseamount')}
                      style={{ cursor: 'pointer', textAlign: 'right' }}
                    >
                      <div className="UI-th-content" style={{ justifyContent: 'flex-end' }}>
                        Amount
                        <this.SortIndicator columnKey="baseamount" />
                      </div>
                    </th>
                    {assetType === "Own" && (
                      <>
                        <th
                          className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                        >
                          Depreciation
                        </th>
                        <th
                          className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                        >
                          Location
                        </th>
                      </>
                    )}
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'createdAt' ? 'UI-th-sorted' : ''}`}
                      onClick={() => this.sortData('createdAt')}
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="UI-th-content">
                        Date
                        <this.SortIndicator columnKey="createdAt" />
                      </div>
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                    >
                      Status
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                      style={{ textAlign: 'center' }}
                    >
                      Actions
                    </th>
                  </>
                ) : type === "Rental" || type === "Sales" ? (
                  <>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'customid' || this.state.sortConfig.key === 'id' ? 'UI-th-sorted' : ''}`}
                      onClick={() =>
                        this.sortData(
                          (type === "Rental" && rentalType === "Rental") ||
                            (type === "Sales" && salesType === "Sales")
                            ? 'customid'
                            : 'id'
                        )
                      }
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="UI-th-content">
                        ID
                        <this.SortIndicator
                          columnKey={
                            (type === "Rental" && rentalType === "Rental") ||
                              (type === "Sales" && salesType === "Sales")
                              ? 'customid'
                              : 'id'
                          }
                        />
                      </div>
                    </th>
                    {((type === "Rental" && rentalType === "Rental") ||
                      (type === "Sales" && salesType === "Sales")) && (
                        <th
                          className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                        >
                          Quotation
                        </th>
                      )}
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                    >
                      Customer
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'totalamountinctax' ? 'UI-th-sorted' : ''}`}
                      onClick={() => this.sortData('totalamountinctax')}
                      style={{ cursor: 'pointer', textAlign: 'right' }}
                    >
                      <div className="UI-th-content" style={{ justifyContent: 'flex-end' }}>
                        Amount
                        <this.SortIndicator columnKey="totalamountinctax" />
                      </div>
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                    >
                      Created By
                    </th>
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${this.state.sortConfig.key === 'createdAt' ? 'UI-th-sorted' : ''}`}
                      onClick={() => this.sortData('createdAt')}
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="UI-th-content">
                        Date
                        <this.SortIndicator columnKey="createdAt" />
                      </div>
                    </th>
                    {((type === "Rental" && rentalType === "Rental") ||
                      (type === "Sales" && salesType === "Sales")) && (
                        <th
                          className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                        >
                          Invoice Status
                        </th>
                      )}
                    <th
                      className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`}
                      style={{ textAlign: 'center' }}
                    >
                      Actions
                    </th>
                  </>
                ) : null}
              </tr>
            </thead>

            <tbody>
              {currentPageData.map((asset) => (
                <tr
                  key={asset.id}
                  className={`UI-table-row ${isMobile ? 'UI-table-row-mobile' : ''} ${this.state.hoveredRow === asset.id ? 'UI-table-row-hovered' : ''}`}
                  onClick={() => this.handleAssetClick(asset)}
                  onMouseEnter={() => this.setState({ hoveredRow: asset.id })}
                  onMouseLeave={() => {
                    this.setState({ hoveredRow: null, isActionHovered: null });
                  }}
                >
                  {type === "Assets" ? (
                    <>
                      {/* ID */}
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                      >
                        {this.highlightSearchText(
                          asset.customid,
                          this.state.searchTerm
                        )}
                      </td>

                      {/* ITEM NAME */}
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-item-name ${this.state.hoveredRow === asset.id ? 'UI-item-name-hover' : ''}`}
                      >
                        {(() => {
                          const name = asset.itemname || "";
                          const lastChar = name.slice(-1);
                          const rest = name.slice(0, -1);

                          return (
                            <>
                              <span>{this.highlightSearchText(rest, this.state.searchTerm)}</span>

                              <Tooltip
                                title="View Details"
                                placement="right"
                                arrow
                                slotProps={{
                                  popper: {
                                    sx: { pointerEvents: 'none' },
                                  },
                                }}
                                open={
                                  !this.state.isMobile &&
                                  this.state.hoveredRow === asset.id &&
                                  !this.state.isActionHovered
                                }
                              >
                                <span style={{ display: "inline-block" }}>
                                  {this.highlightSearchText(lastChar, this.state.searchTerm)}
                                </span>
                              </Tooltip>
                            </>
                          );
                        })()}
                      </td>

                      {/* CATEGORY */}
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                      >
                        {this.highlightSearchText(
                          asset.category,
                          this.state.searchTerm
                        )}
                      </td>

                      {/* ASSET TYPE */}
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                      >
                        {this.highlightSearchText(
                          asset.assettype,
                          this.state.searchTerm
                        )}
                      </td>

                      {/* SERIAL NO. (Only for Own Assets) */}
                      {assetType === "Own" && (
                        <td
                          className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                        >
                          {this.highlightSearchText(
                            asset.serialno,
                            this.state.searchTerm
                          )}
                        </td>
                      )}

                      {/* TYPE (Only for Own Assets) */}
                      {assetType === "Own" && (
                        <td
                          className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                        >
                          {this.highlightSearchText(
                            asset.type,
                            this.state.searchTerm
                          )}
                        </td>
                      )}

                      {/* WAREHOUSE */}
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                      >
                        {this.highlightSearchText(
                          asset.warehouse,
                          this.state.searchTerm
                        )}
                      </td>

                      {/* QUANTITY */}
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                        style={{ textAlign: "center" }}
                      >
                        {asset.quantity}
                      </td>

                      {/* AMOUNT */}
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-amount ${this.state.hoveredRow === asset.id ? 'UI-price-hover' : ''}`}
                        style={{ textAlign: "right" }}
                      >
                        {this.formatCurrency(asset.baseamount)}
                      </td>

                      {/* DEPRECIATION (Only for Own Assets) */}
                      {assetType === "Own" && (
                        <td
                          className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                          style={{ textAlign: "center" }}
                        >
                          {asset.depreciation}%
                        </td>
                      )}

                      {/* LOCATION (Only for Own Assets) */}
                      {assetType === "Own" && (
                        <td
                          className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                        >
                          {this.highlightSearchText(
                            asset.location,
                            this.state.searchTerm
                          )}
                        </td>
                      )}

                      {/* CREATED AT */}
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                      >
                        {this.highlightSearchText(
                          moment(asset.createdAt).format("DD-MM-YYYY HH:mm"),
                          this.state.searchTerm
                        )}
                      </td>

                      {/* STATUS */}
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                      >
                        <span
                          className={`UI-status-badge UI-status-${asset.assetstatus
                            ?.toLowerCase()
                            .replace(' ', '-')}`}
                        >
                          {this.highlightSearchText(
                            asset.assetstatus,
                            this.state.searchTerm
                          )}
                        </span>
                      </td>

                      {/* ACTION BUTTONS */}
                      <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                        <div className="UI-action-buttons">
                          <Link
                            to={{
                              pathname: "/assetdetails",
                            }}
                            state={{
                              data: asset,
                              stype: salesType,
                              type: rentalType,
                              sold: type === "Sales",
                              rent: type === "Rental",
                              active: type === "Assets",
                              assettype: assetType,
                            }}
                            className={`UI-action-button ${isMobile ? 'UI-action-button-mobile' : ''} UI-edit-button`}
                            style={{ textDecoration: "none" }}
                            onClick={(e) => e.stopPropagation()}
                            onMouseEnter={() =>
                              this.setState({
                                isActionHovered: `view-${asset.id}`,
                              })
                            }
                            onMouseLeave={() =>
                              this.setState({ isActionHovered: null })
                            }
                          >
                            <Tooltip
                              title="View Details"
                              arrow
                              slotProps={{
                                popper: {
                                  sx: { pointerEvents: 'none' },
                                },
                              }}
                            >
                              <img
                                src={ViewIcon}
                                alt="View"
                                className={`UI-action-icon ${isMobile ? 'UI-action-icon-mobile' : ''} ${this.state.isActionHovered === `view-${asset.id}`
                                  ? 'UI-edit-icon-hover'
                                  : ''
                                  }`}
                              />
                            </Tooltip>
                          </Link>
                        </div>
                      </td>
                    </>
                  ) : type === "Rental" || type === "Sales" ? (
                    <>
                      {/* ID */}
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                      >
                        {this.highlightSearchText(
                          (type === "Rental" && rentalType === "Rental") ||
                            (type === "Sales" && salesType === "Sales")
                            ? asset.customid
                            : asset.id,
                          this.state.searchTerm
                        )}
                      </td>

                      {/* QUOTATION (Only for Rental/Sales, not Quotation) */}
                      {((type === "Rental" && rentalType === "Rental") ||
                        (type === "Sales" && salesType === "Sales")) && (
                          <td
                            className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                          >
                            {this.highlightSearchText(
                              asset.quotation || "Direct",
                              this.state.searchTerm
                            )}
                          </td>
                        )}

                      {/* CUSTOMER */}
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-item-name`}
                      >
                        {(() => {
                          const name = asset.customer || "";
                          const lastChar = name.slice(-1);
                          const rest = name.slice(0, -1);

                          return (
                            <>
                              <span>{this.highlightSearchText(rest, this.state.searchTerm)}</span>

                              <Tooltip
                                title="View Details"
                                placement="right"
                                arrow
                                slotProps={{
                                  popper: {
                                    sx: { pointerEvents: 'none' },
                                  },
                                }}
                                open={
                                  !this.state.isMobile &&
                                  this.state.hoveredRow === asset.id &&
                                  !this.state.isActionHovered
                                }
                              >
                                <span style={{ display: "inline-block" }}>
                                  {this.highlightSearchText(lastChar, this.state.searchTerm)}
                                </span>
                              </Tooltip>
                            </>
                          );
                        })()}
                      </td>

                      {/* AMOUNT */}
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-amount`}
                        style={{ textAlign: "right" }}
                      >
                        {this.formatCurrency(asset.totalamountinctax)}
                      </td>

                      {/* CREATED BY */}
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                      >
                        {this.highlightSearchText(
                          asset.createdby,
                          this.state.searchTerm
                        )}
                      </td>

                      {/* CREATED AT */}
                      <td
                        className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                      >
                        {this.highlightSearchText(
                          moment(asset.createdAt).format("DD-MM-YYYY HH:mm"),
                          this.state.searchTerm
                        )}
                      </td>

                      {/* INVOICE STATUS (Only for Rental/Sales, not Quotation) */}
                      {((type === "Rental" && rentalType === "Rental") ||
                        (type === "Sales" && salesType === "Sales")) && (
                          <td
                            className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                          >
                            <span
                              className={`UI-status-badge UI-status-${asset.invstatus
                                ?.toLowerCase()
                                .replace(' ', '-')}`}
                            >
                              {this.highlightSearchText(
                                asset.invstatus,
                                this.state.searchTerm
                              )}
                            </span>
                          </td>
                        )}

                      {/* ACTION BUTTONS */}
                      <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                        <div className="UI-action-buttons">
                          <Link
                            to={{
                              pathname: "/assetdetails2",
                            }}
                            state={{
                              data: asset,
                              pagename:
                                type === "Rental"
                                  ? rentalType === "Rental"
                                    ? "Rental Details"
                                    : "Rental Quotation Details"
                                  : salesType === "Sales"
                                    ? "Sales Assets Details"
                                    : "Sales Quotation Details",
                              stype: salesType,
                              type: rentalType,
                              sold: type === "Sales",
                              rent: type === "Rental",
                              active: type === "Assets",
                            }}
                            className={`UI-action-button ${isMobile ? 'UI-action-button-mobile' : ''} UI-edit-button`}
                            style={{ textDecoration: "none" }}
                            onClick={(e) => e.stopPropagation()}
                            onMouseEnter={() =>
                              this.setState({
                                isActionHovered: `view-${asset.id}`,
                              })
                            }
                            onMouseLeave={() =>
                              this.setState({ isActionHovered: null })
                            }
                          >
                            <Tooltip
                              title="View Details"
                              arrow
                              slotProps={{
                                popper: {
                                  sx: { pointerEvents: 'none' },
                                },
                              }}
                            >
                              <img
                                src={ViewIcon}
                                alt="View"
                                className={`UI-action-icon ${isMobile ? 'UI-action-icon-mobile' : ''} ${this.state.isActionHovered === `view-${asset.id}`
                                  ? 'UI-edit-icon-hover'
                                  : ''
                                  }`}
                              />
                            </Tooltip>
                          </Link>
                        </div>
                      </td>
                    </>
                  ) : null}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {this.renderPagination()}
      </>
    );
  }

  renderTypeTabs() {
    const types = ["Assets", "Rental", "Sales"];

    return (
      <div
        className="UI-tabs-row"
        style={{
          marginBottom: "16px",
          marginTop: "10px",
          marginLeft: "10px",
        }}
      >
        {types.map((tabType) => (
          <TabButton
            key={tabType}
            active={this.state.type === tabType}
            onClick={() =>
              this.setState(
                {
                  type: tabType,
                  assetType: tabType === "Assets" ? "Own" : this.state.assetType,
                  rentalType: tabType === "Rental" ? "Rental" : this.state.rentalType,
                  salesType: tabType === "Sales" ? "Sales" : this.state.salesType,
                  currentView: 'list',
                  selectedAsset: null,
                  sortConfig: { key: 'itemname', direction: 'asc' },
                },
                this.updateFilteredData
              )
            }
          >
            {tabType}
          </TabButton>
        ))}
      </div>
    );
  }

  renderStatusTabs() {
    const { type, assetType, rentalType, salesType } = this.state;
    const isMobile = this.state.isMobile;

    if (type === "Assets") {
      const matchCounts = {
        own: this.state.data.length,
        thirdparty: this.state.thirdpartyassets.length,
      };

      const tabs = [
        { key: 'Own', label: 'Own', active: assetType === "Own", count: matchCounts.own },
        { key: 'Thirdparty', label: 'Third Party', active: assetType === "Thirdparty", count: matchCounts.thirdparty },
      ];

      return (
        <div className="UI-quotation-tabs-container">
          {tabs.map((tab) => (
            <div
              key={tab.key}
              className={`UI-quotation-tab ${tab.active ? "UI-quotation-active-tab" : ""
                } ${this.state.hovered === `${tab.key.toLowerCase()}-tab`
                  ? "UI-quotation-tab-hovered"
                  : ""
                }`}
              onClick={() =>
                this.setState({ assetType: tab.key }, this.updateFilteredData)
              }
              onMouseEnter={() =>
                this.setState({ hovered: `${tab.key.toLowerCase()}-tab` })
              }
              onMouseLeave={() => this.setState({ hovered: null })}
            >
              {tab.label}
              {tab.count > 0 && (
                <span className="UI-match-count">{tab.count}</span>
              )}
            </div>
          ))}
        </div>
      );
    } else if (type === "Rental") {
      const matchCounts = {
        rental: this.state.rentdata.length,
        quotation: this.state.rentalquotation.length,
      };

      const tabs = [
        { key: 'Rental', label: 'Rental', active: rentalType === "Rental", count: matchCounts.rental },
        { key: 'Quotation', label: 'Quotation', active: rentalType === "Quotation", count: matchCounts.quotation },
      ];

      return (
        <div className="UI-quotation-tabs-container">
          {tabs.map((tab) => (
            <div
              key={tab.key}
              className={`UI-quotation-tab ${tab.active ? "UI-quotation-active-tab" : ""
                } ${this.state.hovered === `${tab.key.toLowerCase()}-tab`
                  ? "UI-quotation-tab-hovered"
                  : ""
                }`}
              onClick={() =>
                this.setState({ rentalType: tab.key }, this.updateFilteredData)
              }
              onMouseEnter={() =>
                this.setState({ hovered: `${tab.key.toLowerCase()}-tab` })
              }
              onMouseLeave={() => this.setState({ hovered: null })}
            >
              {tab.label}
              {tab.count > 0 && (
                <span className="UI-match-count">{tab.count}</span>
              )}
            </div>
          ))}
        </div>
      );
    } else if (type === "Sales") {
      const matchCounts = {
        sales: this.state.solddata.length,
        quotation: this.state.soldquotations.length,
      };

      const tabs = [
        { key: 'Sales', label: 'Sales', active: salesType === "Sales", count: matchCounts.sales },
        { key: 'Quotation', label: 'Quotation', active: salesType === "Quotation", count: matchCounts.quotation },
      ];

      return (
        <div className="UI-quotation-tabs-container">
          {tabs.map((tab) => (
            <div
              key={tab.key}
              className={`UI-quotation-tab ${tab.active ? "UI-quotation-active-tab" : ""
                } ${this.state.hovered === `${tab.key.toLowerCase()}-tab`
                  ? "UI-quotation-tab-hovered"
                  : ""
                }`}
              onClick={() =>
                this.setState({ salesType: tab.key }, this.updateFilteredData)
              }
              onMouseEnter={() =>
                this.setState({ hovered: `${tab.key.toLowerCase()}-tab` })
              }
              onMouseLeave={() => this.setState({ hovered: null })}
            >
              {tab.label}
              {tab.count > 0 && (
                <span className="UI-match-count">{tab.count}</span>
              )}
            </div>
          ))}
        </div>
      );
    }

    return null;
  }

  renderPagination() {
    const { filteredData, currentPage, itemsPerPage, isMobile } = this.state;

    if (filteredData.length <= itemsPerPage) return null;

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    return (
      <div className={`UI-pagination-container ${isMobile ? 'UI-pagination-container-mobile' : ''}`}>
        <div className={`UI-pagination-info ${isMobile ? 'UI-pagination-info-mobile' : ''}`}>
          Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, filteredData.length)} of {filteredData.length} assets
        </div>
        <div className={`UI-pagination-controls ${isMobile ? 'UI-pagination-controls-mobile' : ''}`}>
          <TextField
            select
            value={itemsPerPage}
            onChange={this.handleItemsPerPageChange}
            variant="outlined"
            size="small"
            className={`UI-page-size-select ${isMobile ? 'UI-page-size-select-mobile' : ''} ${this.state.hovered === 'pagesize' ? 'UI-page-size-select-hover' : ''}`}
            onMouseEnter={() => this.setState({ hovered: 'pagesize' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            <MenuItem value={5}>5 per page</MenuItem>
            <MenuItem value={10}>10 per page</MenuItem>
            <MenuItem value={20}>20 per page</MenuItem>
            <MenuItem value={50}>50 per page</MenuItem>
          </TextField>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === 1 ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'first' && !(currentPage === 1) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(1)}
            disabled={currentPage === 1}
            onMouseEnter={() => !(currentPage === 1) && this.setState({ hovered: 'first' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'First' : 'First'}
          </button>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === 1 ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'prev' && !(currentPage === 1) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            onMouseEnter={() => !(currentPage === 1) && this.setState({ hovered: 'prev' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'Prev' : 'Previous'}
          </button>

          <span className={`UI-pagination-info ${isMobile ? 'UI-pagination-info-mobile' : ''}`}>
            Page {currentPage} of {totalPages}
          </span>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === totalPages ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'next' && !(currentPage === totalPages) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            onMouseEnter={() => !(currentPage === totalPages) && this.setState({ hovered: 'next' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'Next' : 'Next'}
          </button>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === totalPages ? 'UI-pagination-button-disabled' : ''} ${this.state.hovered === 'last' && !(currentPage === totalPages) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => this.handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
            onMouseEnter={() => !(currentPage === totalPages) && this.setState({ hovered: 'last' })}
            onMouseLeave={() => this.setState({ hovered: null })}
          >
            {isMobile ? 'Last' : 'Last'}
          </button>
        </div>
      </div>
    );
  }

  renderDetailView() {
    const { selectedAsset, filteredSidebarData } = this.state;
    if (!selectedAsset) return null;

    const { type, assetType, rentalType, salesType } = this.state;
    const isAssets = type === "Assets";
    const isRental = type === "Rental";
    const isSales = type === "Sales";

    return (
      <div className="UI-detail-view">
        {/* Sidebar */}
        <div className="UI-sidebar">
          <div className="UI-sidebar-header">
            <button
              className={`UI-back-button ${this.state.hovered === 'back' ? 'UI-back-button-hover' : ''}`}
              onClick={this.handleBackToList}
              onMouseEnter={() => this.setState({ hovered: 'back' })}
              onMouseLeave={() => this.setState({ hovered: null })}
            >
              <i className="fa fa-arrow-left" /> Back
            </button>
          </div>
          <div className="UI-sidebar-list" ref={this.sidebarRef}>
            {filteredSidebarData.map((asset) => (
              <div
                key={asset.id}
                data-asset-id={asset.id}
                className={`UI-sidebar-item ${selectedAsset.id === asset.id ? 'UI-sidebar-item-active' : ''} ${this.state.hovered === asset.id ? 'UI-sidebar-item-hover' : ''}`}
                onClick={() => this.setState({ selectedAsset: asset })}
                onMouseEnter={() => this.setState({ hovered: asset.id })}
                onMouseLeave={() => this.setState({ hovered: null })}
              >
                <div className={`UI-sidebar-item-name ${this.state.hovered === asset.id ? 'UI-sidebar-item-name-hover' : ''}`}>
                  {isAssets ? asset.itemname : asset.customer}
                </div>
                <div className={`UI-sidebar-item-code ${this.state.hovered === asset.id ? 'UI-sidebar-item-code-hover' : ''}`}>
                  {isAssets ? asset.customid :
                    (isRental && rentalType === "Rental") || (isSales && salesType === "Sales")
                      ? asset.customid : asset.id}
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* Detail Content */}
        <div className="UI-detail-content">
          <div className="UI-detail-header">
            <div className="UI-detail-title-wrapper">
              <h2 className="UI-detail-title">
                {isAssets ? selectedAsset.itemname : selectedAsset.customer}
              </h2>
              <p className="UI-detail-subtitle">
                {isAssets
                  ? `ID: ${selectedAsset.customid}`
                  : isRental && rentalType === "Rental"
                    ? `ID: ${selectedAsset.customid}`
                    : isSales && salesType === "Sales"
                      ? `ID: ${selectedAsset.customid}`
                      : `ID: ${selectedAsset.id}`
                }
              </p>
            </div>
            <div className="UI-detail-actions">
              <Link
                to={
                  isAssets
                    ? { pathname: "/assetdetails" }
                    : { pathname: "/assetdetails2" }
                }
                state={
                  isAssets
                    ? {
                      data: selectedAsset,
                      stype: salesType,
                      type: rentalType,
                      sold: isSales,
                      rent: isRental,
                      active: isAssets,
                      assettype: assetType,
                    }
                    : {
                      data: selectedAsset,
                      pagename: isRental
                        ? rentalType === "Rental"
                          ? "Rental Details"
                          : "Rental Quotation Details"
                        : salesType === "Sales"
                          ? "Sales Assets Details"
                          : "Sales Quotation Details",
                      stype: salesType,
                      type: rentalType,
                      sold: isSales,
                      rent: isRental,
                      active: isAssets,
                    }
                }
                className={`UI-detail-action-button UI-detail-edit-button ${this.state.hovered === "view" ? 'UI-edit-button-hover' : ''}`}
                style={{ textDecoration: "none" }}
                onMouseEnter={() => this.setState({ hovered: "view" })}
                onMouseLeave={() => this.setState({ hovered: null })}
              >
                <Tooltip
                  title="View Full Details"
                  arrow
                  slotProps={{
                    popper: {
                      sx: { pointerEvents: 'none' },
                    },
                  }}
                >
                  <img
                    src={ViewIcon}
                    alt="View"
                    className={`UI-action-icon ${this.state.hovered === "view" ? 'UI-action-icon-hover' : ''}`}
                  />
                </Tooltip>
              </Link>
            </div>
          </div>
          <div className="UI-detail-grid">
            {/* Basic Information */}
            <div className="UI-detail-section">
              <h3 className="UI-section-title">Basic Information</h3>
              {isAssets ? (
                <>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Item Name</span>
                    <span className="UI-detail-value">{selectedAsset.itemname}</span>
                  </div>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">ID</span>
                    <span className="UI-detail-value">{selectedAsset.customid}</span>
                  </div>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Category</span>
                    <span className="UI-detail-value">{selectedAsset.category}</span>
                  </div>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Asset Type</span>
                    <span className="UI-detail-value">{selectedAsset.assettype}</span>
                  </div>
                  {assetType === "Own" && (
                    <>
                      <div className="UI-detail-row">
                        <span className="UI-detail-label">Serial No.</span>
                        <span className="UI-detail-value">{selectedAsset.serialno}</span>
                      </div>
                      <div className="UI-detail-row">
                        <span className="UI-detail-label">Type</span>
                        <span className="UI-detail-value">{selectedAsset.type}</span>
                      </div>
                    </>
                  )}
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Warehouse</span>
                    <span className="UI-detail-value">{selectedAsset.warehouse}</span>
                  </div>
                </>
              ) : isRental || isSales ? (
                <>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Customer</span>
                    <span className="UI-detail-value">{selectedAsset.customer}</span>
                  </div>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">ID</span>
                    <span className="UI-detail-value">
                      {(isRental && rentalType === "Rental") ||
                        (isSales && salesType === "Sales")
                        ? selectedAsset.customid
                        : selectedAsset.id}
                    </span>
                  </div>
                  {((isRental && rentalType === "Rental") ||
                    (isSales && salesType === "Sales")) && (
                      <div className="UI-detail-row">
                        <span className="UI-detail-label">Quotation</span>
                        <span className="UI-detail-value">
                          {selectedAsset.quotation || "Direct"}
                        </span>
                      </div>
                    )}
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Created By</span>
                    <span className="UI-detail-value">{selectedAsset.createdby}</span>
                  </div>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Created Date</span>
                    <span className="UI-detail-value">
                      {moment(selectedAsset.createdAt).format("DD-MM-YYYY HH:mm")}
                    </span>
                  </div>
                </>
              ) : null}
            </div>

            {/* Financial & Status Information */}
            <div className="UI-detail-section">
              <h3 className="UI-section-title">
                {isAssets ? "Financial & Status Information" : "Financial Information"}
              </h3>
              {isAssets ? (
                <>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Quantity</span>
                    <span className="UI-detail-value">{selectedAsset.quantity}</span>
                  </div>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Amount</span>
                    <span className="UI-detail-value">
                      {this.formatCurrency(selectedAsset.baseamount)}
                    </span>
                  </div>
                  {assetType === "Own" && (
                    <>
                      <div className="UI-detail-row">
                        <span className="UI-detail-label">Depreciation</span>
                        <span className="UI-detail-value">{selectedAsset.depreciation}%</span>
                      </div>
                      <div className="UI-detail-row">
                        <span className="UI-detail-label">Depreciation Period</span>
                        <span className="UI-detail-value">
                          {selectedAsset.depreciationperiod}
                        </span>
                      </div>
                      <div className="UI-detail-row">
                        <span className="UI-detail-label">Depreciation Frequency</span>
                        <span className="UI-detail-value">
                          {selectedAsset.depreciationfrequency}
                        </span>
                      </div>
                    </>
                  )}
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Status</span>
                    <span className="UI-detail-value">
                      <span
                        className={`UI-status-badge UI-status-${selectedAsset.assetstatus
                          ?.toLowerCase()
                          .replace(' ', '-')}`}
                      >
                        {selectedAsset.assetstatus}
                      </span>
                    </span>
                  </div>
                </>
              ) : isRental || isSales ? (
                <>
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">Total Amount</span>
                    <span className="UI-detail-value">
                      {this.formatCurrency(selectedAsset.totalamountinctax)}
                    </span>
                  </div>
                  {((isRental && rentalType === "Rental") ||
                    (isSales && salesType === "Sales")) && (
                      <div className="UI-detail-row">
                        <span className="UI-detail-label">Invoice Status</span>
                        <span className="UI-detail-value">
                          <span
                            className={`UI-status-badge UI-status-${selectedAsset.invstatus
                              ?.toLowerCase()
                              .replace(' ', '-')}`}
                          >
                            {selectedAsset.invstatus}
                          </span>
                        </span>
                      </div>
                    )}
                </>
              ) : null}
            </div>

            {/* Additional Information */}
            <div className="UI-detail-section">
              <h3 className="UI-section-title">Additional Information</h3>
              {isAssets ? (
                <>
                  {assetType === "Own" && (
                    <div className="UI-detail-row">
                      <span className="UI-detail-label">Location</span>
                      <span className="UI-detail-value">{selectedAsset.location}</span>
                    </div>
                  )}
                  <div className="UI-detail-row">
                    <span className="UI-detail-label">User</span>
                    <span className="UI-detail-value">{selectedAsset.user}</span>
                  </div>
                </>
              ) : null}
              <div className="UI-detail-row">
                <span className="UI-detail-label">Created Date</span>
                <span className="UI-detail-value">
                  {moment(selectedAsset.createdAt).format("DD-MM-YYYY HH:mm")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderListView() {
    return (
      <>
        {this.renderTypeTabs()}
        {this.renderStatusTabs()}
        {this.renderTable()}
      </>
    );
  }

  render() {
    const isMobile = this.state.isMobile;
    const { type, assetType, rentalType, salesType } = this.state;

    return (
      <div>
        <Header />
        <Menu />
        <div className="content-wrapper">
          <div className={`UI-container ${isMobile ? 'UI-container-mobile' : ''}`}>
            <div className="UI-card">
              {/* Header */}
              <div className={`UI-header ${isMobile ? 'UI-header-mobile' : ''}`}>
                <nav className={`UI-breadcrumb ${isMobile ? 'UI-breadcrumb-mobile' : ''}`}>
                  <Link
                    to="/assetmanagement"
                    className={`UI-breadcrumb-item ${this.state.hovered === 'home' ? 'UI-breadcrumb-item-hover' : ''}`}
                    onMouseEnter={() => this.setState({ hovered: 'home' })}
                    onMouseLeave={() => this.setState({ hovered: null })}
                  >
                    Home
                  </Link>
                  <span>/</span>
                  <span className={`UI-breadcrumb-item UI-breadcrumb-active`}>
                    Assets Management
                  </span>
                </nav>
                <div className={`UI-header-content ${isMobile ? 'UI-header-content-mobile' : ''}`}>
                  <div>
                    <h1 className={`UI-title ${isMobile ? 'UI-title-mobile' : ''}`}>
                      Assets Management
                    </h1>
                    <p className={`UI-subtitle ${isMobile ? 'UI-subtitle-mobile' : ''}`}>
                      {this.state.currentView === 'detail' && this.state.selectedAsset
                        ? `ID: ${type === "Assets"
                          ? this.state.selectedAsset.customid
                          : (type === "Rental" && rentalType === "Rental") ||
                            (type === "Sales" && salesType === "Sales")
                            ? this.state.selectedAsset.customid
                            : this.state.selectedAsset.id
                        }`
                        : 'Manage your assets, rentals, and sales'}
                    </p>
                  </div>
                  <div className={`UI-header-actions ${isMobile ? 'UI-header-actions-mobile' : ''}`}>
                    {/* Desktop Search */}
                    {!isMobile && (
                      <div
                        className={`UI-search-container ${this.state.showSearch ? 'UI-search-container-expanded' : ''} ${this.state.hovered === "search" ? 'UI-search-container-hover' : ''}`}
                        onClick={() => {
                          if (!this.state.showSearch) this.setState({ showSearch: true });
                        }}
                        onMouseEnter={() => this.setState({ hovered: "search" })}
                        onMouseLeave={() => this.setState({ hovered: null })}
                      >
                        <i className={`fa fa-search UI-search-icon ${this.state.hovered === "search" ? 'UI-search-container-hover' : ''}`} />
                        {!this.state.showSearch && "Search"}
                        {this.state.showSearch && (
                          <input
                            type="text"
                            className="UI-search-input"
                            placeholder="Search assets..."
                            value={this.state.searchTerm}
                            onChange={(e) => this.handleSearch(e.target.value)}
                            autoFocus
                            onClick={(e) => e.stopPropagation()}
                            onBlur={() => {
                              if (this.state.searchTerm.trim() === "") {
                                this.setState({ showSearch: false });
                              }
                            }}
                          />
                        )}
                      </div>
                    )}
                    {/* Mobile Search */}
                    {isMobile && (
                      <input
                        type="text"
                        className="UI-mobile-search-input"
                        placeholder="Search assets..."
                        value={this.state.searchTerm}
                        onChange={(e) => this.handleSearch(e.target.value)}
                      />
                    )}
                    {/* Export dropdown */}
                    {(assetmanagementid === "2" || assetmanagementid === "3") && (
                      <div className="UI-export-container" ref={this.exportRef}>
                        <button
                          className={`UI-btn ${isMobile ? 'UI-btn-mobile' : ''} UI-btn-outline ${this.state.hovered === "export" ? 'UI-btn-outline-hover' : ''}`}
                          onClick={this.toggleExportDropdown}
                          onMouseEnter={() => this.setState({ hovered: "export" })}
                          onMouseLeave={() => this.setState({ hovered: null })}
                        >
                          <i className="fa fa-file-export" />{' '}
                          {isMobile ? "Export" : "Export"}
                          <i className="fa fa-caret-down" style={{ marginLeft: '4px' }} />
                        </button>
                        {this.state.exportDropdownOpen && (
                          <div className="UI-export-dropdown">
                            <button
                              className="UI-export-option"
                              onClick={this.exportPDF}
                              onMouseEnter={() => this.setState({ hovered: "exportPDF" })}
                              onMouseLeave={() => this.setState({ hovered: null })}
                            >
                              <i className="fa fa-file-pdf" /> PDF Export
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                    {/* New Asset button */}
                    {(assetmanagementid === "2" || assetmanagementid === "3") && (
                      <Link
                        to={{
                          pathname:
                            type === "Assets"
                              ? assetType === "Own"
                                ? "/newasset"
                                : "/newthirdpartyasset"
                              : "/rentasset",
                        }}
                        state={{
                          id: -1,
                          pagename:
                            type === "Assets"
                              ? assetType === "Own"
                                ? "New Asset"
                                : "New Third Party Asset"
                              : type === "Rental"
                                ? rentalType === "Rental"
                                  ? "New Rent Asset"
                                  : "New Rental Quotation"
                                : salesType === "Sales"
                                  ? "New Sales Asset"
                                  : "New Sales Quotation",
                          stype: salesType,
                          type: rentalType,
                          sold: type === "Sales",
                          rent: type === "Rental",
                          active: type === "Assets",
                        }}
                        className={`UI-btn ${isMobile ? 'UI-btn-mobile' : ''} UI-btn-primary ${this.state.hovered === "new" ? 'UI-btn-primary-hover' : ''}`}
                        style={{ textDecoration: "none" }}
                        onMouseEnter={() => this.setState({ hovered: "new" })}
                        onMouseLeave={() => this.setState({ hovered: null })}
                      >
                        <i className="fa fa-plus" />{' '}
                        {isMobile
                          ? "New"
                          : type === "Assets"
                            ? assetType === "Own"
                              ? "New Asset"
                              : "New Third Party"
                            : type === "Rental"
                              ? rentalType === "Rental"
                                ? "New Rental"
                                : "New Rental Quote"
                              : salesType === "Sales"
                                ? "New Sale"
                                : "New Sales Quote"}
                      </Link>
                    )}
                  </div>
                </div>
              </div>

              {this.state.loading ? (
                <div className="UI-loading-container">{spin}</div>
              ) : (
                <div style={{ marginTop: '8px' }}>
                  {this.state.currentView === 'list'
                    ? this.renderListView()
                    : this.renderDetailView()
                  }
                </div>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withRouter(AssetTable);